exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "html{box-sizing:border-box}*,:after,:before{box-sizing:inherit}.mini-notice{border-radius:8px;border:1px solid #bfbfbf;color:#212121;display:flex;flex-wrap:wrap;margin-bottom:8px;padding:8px 12px 6px}.mini-notice__note{font-size:14px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader!./app/components/miniNotice.scss
// module id = 971
// module chunks = 0